@layer design-system {
  .styledBlockquote {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
  }

  .textWrapper {
    display: flex;
    flex-direction: column;
  }
}
